import enhance from './PaginationControl.enhancer'
import PaginationControl from './PaginationControl'

export default enhance(PaginationControl)



// WEBPACK FOOTER //
// ./src/components/organisms/PaginationControl/index.js